/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */
import { v4 as uuid } from "uuid";

export const videos = [
  {
    _id: uuid(),
    link: "Y2Oj9gllHno",
    thumbnail: "Y2Oj9gllHno/hqdefault",
    avatar: "ytc/AKedOLSvPEUzOL_qQkQQd17lcsvj3ikeb2iEj92MUBi91A",
    title: "I am a Chef | Aakash Gupta | Stand-Up Comedy | Crowd Work",
    description:
      "This crowd work was improvised on the spot in one of the live shows. Thanks to Shubham for being such an amazing sport. Hope to see u in US and have some french cusiine together :P ",
    views: "10M",
    days: "62 minutes ago",
    time: "08:54",
    creator: "Aakash Gupta",
  },
  {
    _id: uuid(),
    link: "MLdXYEWTC1k&t=167s",
    thumbnail: "MLdXYEWTC1k/hq720",
    avatar: "ytc/AKedOLQ-IPFEzpiA0AqSSeK7ZiBWUfrG4a3OZar2p3tXNQ",
    title: "Bahut Pighle Hain | Zakir khan | Stand-Up Comedy | Sukha poori 6",
    description:
      "In his latest standup video, Zakir Khan talks about the little things his mom does, his thoughts on the gym, and flaunts his bargaining skills with stories of his first kiss and run-ins at the gym with a trainer and a gym guy!",
    views: "17M",
    days: "10 June 2021",
    time: "13:09",
    creator: "Zakir khan",
  },
  {
    _id: uuid(),
    link: "c7QYEedjb_o&t=3s",
    thumbnail: "c7QYEedjb_o/hq720",
    avatar: "ytc/AKedOLQFBbx9iNh-JQvEo61AHkcDrkbY-Pavaba-y2ck9w",
    title:
      "ABHISHEK UPMANYU |Friends, Crime, & The Cosmos | Stand-Up Comedy by Abhishek Upmanyu",
    description:
      "Jokes about Friends, Crime Patrol and The Cosmos. Hope you enjoy it!",
    views: "49M",
    days: "8 May 2019",
    time: "15:01",
    creator: "Abhishek Upmanyu",
  },
  {
    _id: uuid(),
    link: "vTrH8mr0C4g",
    thumbnail: "vTrH8mr0C4g/hq720",
    avatar: "ytc/AKedOLT4Em51isWMSdGWnXAjOQr-D2WRCnnbGQbRXjyj1JU",
    title:
      "Gujarati, Muslims & Global Warming | Standup Comedy by Munawar Faruqui | 2022",
    description:
      "Join and get early updates on live shows in your city, content, and merchandise",
    views: "9.9M",
    days: "1 Feb 2022",
    time: "18:37",
    creator: "Munawar Faruqui",
  },
  {
    _id: uuid(),
    link: "g1T8-WSYcdI&t=602s",
    thumbnail: "g1T8-WSYcdI/hqdefault",
    avatar:
      "tQRnHeVFIYQ7DTAcGpQHXwEZeq7u7b3geX_MQ3ON0QcXq8nCL6_WJiwnkPYWRzBwrljscCIMFA",
    title: "Middle Class bhi Nahi Hoon | Standup Comedy ft. Haseeb Khan",
    description:
      "Shot and recorded by The Habitat Team at a live standup comedy event at The Habitat, Mumbai.",
    views: "4.9M",
    days: "11 March 2022",
    time: "11:19",
    creator: "Haseeb Khan",
  },
  {
    _id: uuid(),
    link: "8f3e6rXB8Cw",
    thumbnail: "8f3e6rXB8Cw/hq720",
    avatar: "ytc/AKedOLTuDOpO2Vc50eR-mu8HjPzDXwnZkqUW_ZDCoQQGCg",
    title: "My name is Harsh Gujral - Standup Comedy",
    description:
      "DO SHARE YOUR EXPERIENCES IF YOUR ARE ALSO A 'BROTHER BORN AFTER SISTERS'.",
    views: "12M",
    days: "19 April 2021",
    time: "14:54",
    creator: "Harsh Gujral",
  },
  {
    _id: uuid(),
    link: "6d2wzfx4sRs",
    thumbnail: "6d2wzfx4sRs/hq720",
    avatar: "ytc/AKedOLSvPEUzOL_qQkQQd17lcsvj3ikeb2iEj92MUBi91A",
    title: "Paan | Stand-up Comedy by Aakash Gupta",
    description:
      "Join and get early updates on live shows in your city, content, and merchandise",
    views: "12M",
    days: "20 Feb 2022",
    time: "08:11",
    creator: "Aakash Gupta",
  },
  {
    _id: uuid(),
    link: "sIl8vsWrD8o",
    thumbnail: "sIl8vsWrD8o/hqdefault",
    avatar: "ytc/AKedOLQ-IPFEzpiA0AqSSeK7ZiBWUfrG4a3OZar2p3tXNQ",
    title: "Zakir Khan - When I met a Delhi Girl | AIB Diwas",
    description: "Performance at AIB Diwas!",
    views: "68M",
    days: "6 May 2016",
    time: "11:41",
    creator: "Zakir Khan",
  },
  {
    _id: uuid(),
    link: "dtaJzUbQS7E",
    thumbnail: "dtaJzUbQS7E/hq720",
    avatar: "ytc/AKedOLQFBbx9iNh-JQvEo61AHkcDrkbY-Pavaba-y2ck9w",
    title: "Marriage & Indian English | Stand-Up Comedy by Abhishek Upmanyu",
    description:
      "Join and get early updates on live shows in your city, content, and merchandise",
    views: "29M",
    days: "24 Oct 2019",
    time: "08:08",
    creator: "Abhishek Upmanyu",
  },
  {
    _id: uuid(),
    link: "UMUbAvDYh9k",
    thumbnail: "UMUbAvDYh9k/hq720",
    avatar: "ytc/AKedOLT4Em51isWMSdGWnXAjOQr-D2WRCnnbGQbRXjyj1JU",
    title: "Ghost Story | Standup Comedy | Munawar Faruqui 2021",
    description:
      "Join and get early updates on live shows in your city, content, and merchandise",
    views: "17M",
    days: "28 Feb 2021",
    time: "12:46",
    creator: "Munawar Faruqui",
  },
  {
    _id: uuid(),
    link: "pzPCJj1U8bE&t=230s",
    thumbnail: "pzPCJj1U8bE/hqdefault",
    avatar:
      "tQRnHeVFIYQ7DTAcGpQHXwEZeq7u7b3geX_MQ3ON0QcXq8nCL6_WJiwnkPYWRzBwrljscCIMFA",
    title: "Main Karachi se Hoon - Stand Up Comedy ft. Haseeb Khan",
    description: "MY FIRST STAND UP VIDEO IS HERE! ",
    views: "6.6M",
    days: "13 Nov 2021",
    time: "09:41",
    creator: "Haseeb Khan",
  },
  {
    _id: uuid(),
    link: "8KFi3ag9bEs",
    thumbnail: "8KFi3ag9bEs/hq720",
    avatar: "ytc/AKedOLTuDOpO2Vc50eR-mu8HjPzDXwnZkqUW_ZDCoQQGCg",
    title:
      "Sasta Vicky Kaushal | CROWD WORK | Harsh Gujral | Standup Comedy 2021",
    description:
      "Releasing my 5th Video crowd-work(Standup Comedy) video from the show that I did in New Delhi my first show after Lockdown. Crowd work is a sub-genre of stand up comedy, which is completely unscripted and based purely on audience interactions. Let me know how you liked the video and share it with your friends",
    views: "10M",
    days: "23 Dec 2020",
    time: "13:10",
    creator: "Harsh Gujral",
  },
  {
    _id: uuid(),
    link: "KBZfnt80s54&t=21s",
    thumbnail: "KBZfnt80s54/hq720",
    avatar: "ytc/AKedOLSvPEUzOL_qQkQQd17lcsvj3ikeb2iEj92MUBi91A",
    title:
      "Sarojini Nagar | Excuse Me Brother | Stand-Up Comedy by Aakash Gupta",
    description:
      "Shot and recorded by The Habitat Team at a live standup comedy event at The Habitat, Mumbai.",
    views: "26M",
    days: " 25 Feb 2021",
    time: "10:30",
    creator: "Aakash Gupta",
  },
  {
    _id: uuid(),
    link: "B9nTWeqund8",
    thumbnail: "B9nTWeqund8/hq720",
    avatar: "ytc/AKedOLQ-IPFEzpiA0AqSSeK7ZiBWUfrG4a3OZar2p3tXNQ",
    title: "Babu Khana Kha lo | Zakir Khan | Stand-Up Comedy | Sukha poori 5",
    description: "Video edited by Akshay Gade",
    views: "12M",
    days: "2 Jun 2020",
    time: "05:41",
    creator: "Zakir Khan",
  },
  {
    _id: uuid(),
    link: "HQILxqS831E",
    thumbnail: "HQILxqS831E/hq720",
    avatar: "ytc/AKedOLQFBbx9iNh-JQvEo61AHkcDrkbY-Pavaba-y2ck9w",
    title:
      "Names & Pigeons | Trash Jokes 4 | Ghatia Comedy by Abhishek Upmanyu",
    description: "Meri taraf se ek aur ghatia peshkash",
    views: "17M",
    days: "23 Jan 2020",
    time: "08:29",
    creator: "Abhishek Upmanyu",
  },
  {
    _id: uuid(),
    link: "cHLM9L_5gj0",
    thumbnail: "cHLM9L_5gj0/hq720",
    avatar: "ytc/AKedOLT4Em51isWMSdGWnXAjOQr-D2WRCnnbGQbRXjyj1JU",
    title:
      "Doctor & Engineer | Crowd Work | Stand-Up Comedy By Munawar Faruqui",
    description:
      "Join and get early updates on live shows in your city, content, and merchandise",
    views: "17M",
    days: "1 May 2021",
    time: "20:45",
    creator: "Munawar Faruqui",
  },
  {
    _id: uuid(),
    link: "hj4kzcdd8ZE",
    thumbnail: "hj4kzcdd8ZE/hqdefault",
    avatar: "ytc/AKedOLTuDOpO2Vc50eR-mu8HjPzDXwnZkqUW_ZDCoQQGCg",
    title: "Shadi Ki Rasmein - Standup Comedy ft. Harsh Gujral",
    description: "MY SECOND STAND UP VIDEO IS HERE!",
    views: "19M",
    days: "5 Sept 2019",
    time: "11:14",
    creator: "Harsh Gujral",
  },
  {
    _id: uuid(),
    link: "PTIaBLtp4R8",
    thumbnail: "PTIaBLtp4R8/hq720",
    avatar: "ytc/AKedOLSvPEUzOL_qQkQQd17lcsvj3ikeb2iEj92MUBi91A",
    title: "Dogs | Stand-Up Comedy by Aakash Gupta",
    description:
      "Jokes about my fear of dogs & dog-owners. Hope you all like it :)",
    views: "25M",
    days: "27 Oct 2019",
    time: "07:41",
    creator: "Aakash Gupta",
  },
  {
    _id: uuid(),
    link: "2V1shb3Mi4s&t=3s",
    thumbnail: "2V1shb3Mi4s/hqdefault",
    avatar: "ytc/AKedOLQ-IPFEzpiA0AqSSeK7ZiBWUfrG4a3OZar2p3tXNQ",
    title: "Bhai Tumhara Superman | Zakir khan | Comedy",
    description:
      "Jodhpur, Patna, Bilaspur, Bhubaneshwar, Kolkata aur Pune toh aa hi rahe hain baki yeh link dekhte rahiyega! ",
    views: "16M",
    days: "10 Dec 2019",
    time: "12:37",
    creator: "Zakir Khan",
  },
];
